import React from 'react';
import { Loader } from '~/components/Loader/loader';

const LoadingButton: React.FC = () => <Loader title="Loading more..." />;

LoadingButton.propTypes = {};

export default LoadingButton;
